module.exports = __webpack_public_path__ + "img/cover-page-icon.a11a331e.svg";